import { cn } from "@/lib/utils";

export function ServiceHighlightCard({
  title,
  description,
  empty,
  value,
  detail,
  tone = "default",
}: {
  title: string;
  description: string;
  empty: boolean;
  value?: string;
  detail?: string;
  tone?: "default" | "gold";
}) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">{title}</p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">{description}</p>
      {empty ? (
        <p className="py-8 text-center text-[11.5px] text-muted-foreground">
          Aucune donnée sur cette période.
        </p>
      ) : (
        <p
          className={cn(
            "text-[20px] font-bold",
            tone === "gold" ? "text-brand-gold-dark" : "text-body",
          )}
        >
          {value}
          {detail && (
            <span className="ml-2 text-[12px] font-normal text-muted-foreground">{detail}</span>
          )}
        </p>
      )}
    </div>
  );
}
